import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Navbar from './NavBar';

const MainNavbar = ({ user }) => {

  return (
    <Navbar user={user} />
  );
};

MainNavbar.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
  }),
};

export default MainNavbar;
